import {forwardRef} from 'react'
import classNames from 'classnames'
import type {TabsValue} from './context'
import {useTabs} from './context'
import type {CommonProps} from '../@types/common'

export interface TabContentProps extends CommonProps {
  value: TabsValue
}

const TabContent = forwardRef<HTMLDivElement, TabContentProps>((props, ref) => {
  const {value, children, className, ...rest} = props

  const context = useTabs()
  const isSelected = value === context.value

  const tabContentClass = classNames(
      'tab-content',
      'mt-4 p-6 bg-white rounded-xl border border-slate-200 shadow-sm',
      'backdrop-blur-sm bg-white/90',
      'transition-all duration-300 ease-in-out',
      isSelected && [
        'tab-content-active',
        'opacity-100',
        'transform translate-y-0',
        'animate-fadeIn'
      ],
      !isSelected && [
        'opacity-0',
        'transform translate-y-2',
        'pointer-events-none',
        'hidden'
      ],
      className
  )

  return (
      <div
          ref={ref}
          role="tabpanel"
          tabIndex={0}
          className={tabContentClass}
          {...rest}
      >
        {isSelected && (
            <div className="animate-slideIn">
              {children}
            </div>
        )}
      </div>
  )
})

TabContent.displayName = 'TabContent'

export default TabContent